import { BUSINESS } from '@/consts/business';
import { FULL_SERVICE_AREA_NAMES } from '@/consts/service-areas';
import { SERVICE_TYPES } from '@/consts/services';

export const SITE_URL = BUSINESS.siteUrl;
export const SITE_NAME = BUSINESS.displayName;
export const SITE_LOCALE = 'fr_CA';
export const DEFAULT_SOCIAL_IMAGE_URL = `${SITE_URL}/og.webp`;
export const DEFAULT_X_SOCIAL_IMAGE_URL = `${SITE_URL}/og_x.webp`;
export const DEFAULT_SOCIAL_IMAGE_TYPE = 'image/webp';
export const DEFAULT_SOCIAL_IMAGE_WIDTH = '1200';
export const DEFAULT_SOCIAL_IMAGE_HEIGHT = '630';
export const DEFAULT_SOCIAL_IMAGE_ALT =
  'Apex Prestige : nettoyage de vitres à Sherbrooke et environs';

export const HOME_SEO_DEFAULT = {
  title: 'Apex Prestige | Nettoyage extérieur à Sherbrooke et environs',
  description:
    'Services de nettoyage extérieur résidentiel et commercial à Sherbrooke, Magog, Orford, Bromont et dans les municipalités environnantes : vitres, gouttières, soffites, revêtement, toiture, pavé uni et lavage à pression.',
  keywords:
    'nettoyage extérieur Sherbrooke, nettoyage de vitres Sherbrooke, nettoyage de gouttières Sherbrooke, lavage à pression Sherbrooke, nettoyage extérieur Magog, nettoyage extérieur Orford, nettoyage extérieur Bromont, nettoyage de toiture, nettoyage de pavé uni, sable polymère, Apex Prestige',
  ogTitle: 'Apex Prestige | Services de nettoyage extérieur à Sherbrooke',
  ogDescription:
    'Nettoyage et entretien extérieur à Sherbrooke, Magog, Orford, Bromont et dans les municipalités environnantes.',
  ogUrl: SITE_URL,
  geoRegion: 'CA-QC',
  geoPlacename: 'Sherbrooke, Magog, Orford, Bromont',
  canonicalUrl: SITE_URL,
} as const;

export const BASE_LOCAL_BUSINESS_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: BUSINESS.fullName,
  alternateName: BUSINESS.displayName,
  description:
    'Services de nettoyage et d’entretien extérieur pour les propriétés résidentielles et commerciales à Sherbrooke, Magog, Orford, Bromont et dans les municipalités environnantes.',
  url: SITE_URL,
  telephone: BUSINESS.phone,
  email: BUSINESS.email,
  logo: `${SITE_URL}/logo.webp`,
  image: `${SITE_URL}/hero.webp`,
  areaServed: [...FULL_SERVICE_AREA_NAMES],
  serviceType: SERVICE_TYPES,
  sameAs: [BUSINESS.facebook],
} as const;
